import store from '@/store'
import Vue from 'vue'
import { Stocks } from './Calculator'

export default new Vue({
  store,
  methods: {
    calculate(order) {
      const pickPlan = {
        open: [],
        missing: {},
        productStats: {
          total: 0,
          picked: 0,
          packed: 0,
          missing: 0
        }
      }
      const products = {}
      order?.residents?.forEach(resident => {
        resident?.shoppingList?.items?.forEach(item => {
          if (!products[item.productId]) products[item.productId] = { required: 0, picked: 0 }
          if (item.packed) pickPlan.productStats.packed += item.packed
          products[item.productId].required += item.amount
        })
      })

      order?.homeOrder?.shoppingList?.items?.forEach(item => {
        if (!products[item.productId]) products[item.productId] = { required: 0, picked: 0 }
        if (item.packed) pickPlan.productStats.packed += item.packed
        products[item.productId].required += item.amount
      })

      order?.kioskOrder?.items?.forEach(item => {
        if (!products[item.productId]) products[item.productId] = { required: 0, picked: 0 }
        if (item.packed) pickPlan.productStats.packed += item.packed
        products[item.productId].required += item.amount
      })

      order?.pickedItems?.forEach(pick => {
        products[pick.productId].picked += pick.amount
        pickPlan.productStats.picked += pick.amount
      })

      Object.keys(products).forEach(productId => {
        const stocks = Stocks(productId, this.$store.state.shelves)
        let itemsRequired = products[productId].required - products[productId].picked
        pickPlan.productStats.total += products[productId].required
        stocks.forEach(stock => {
          if (itemsRequired > 0) {
            const amount = itemsRequired <= stock.amount ? itemsRequired : stock.amount
            pickPlan.open.push({
              productId,
              shelfSpaceId: stock.shelfSpaceId,
              expiryDate: stock.expiryDate,
              amount
            })
            itemsRequired -= amount
          }
        })
        if (itemsRequired !== 0) {
          pickPlan.missing[productId] = itemsRequired
          pickPlan.productStats.missing += itemsRequired
        }
      })

      const exampleSort = [
        'P94',
        'L02',
        'L01',
        'K02',
        'K01',
        'J01',
        'J02',
        'J03',
        'J04',
        'P40',
        'P41',
        'P42',
        'P43',
        'P44',
        'P45',
        'P46',
        'P47',
        'P48',
        'P60',
        'P61',
        'P62',
        'P63',
        'P64',
        'P65',
        'P66',
        'P67',
        'P68',
        'P11',
        'P10',
        'P09',
        'P28',
        'P08',
        'P27',
        'P07',
        'P26',
        'P06',
        'P25',
        'P05',
        'P24',
        'P04',
        'P23',
        'P03',
        'P22',
        'P21',
        'P20',
        'P90',
        'P91',
        'P92',
        'P93',
        'I04',
        'I03',
        'I02',
        'A08',
        'I01',
        'A07',
        'A06',
        'B08',
        'A05',
        'B07',
        'B06',
        'A04',
        'B05',
        'A03',
        'B04',
        'A02',
        'B03',
        'A01',
        'B02',
        'B01',
        'C01',
        'D01',
        'C02',
        'D02',
        'C03',
        'D03',
        'C04',
        'D04',
        'C05',
        'D05',
        'C06',
        'D06',
        'C07',
        'D07',
        'C08',
        'D08',
        'E08',
        'F08',
        'E07',
        'F07',
        'E06',
        'F06',
        'E05',
        'F05',
        'E04',
        'F04',
        'E03',
        'F03',
        'E02',
        'F02',
        'E01',
        'F01'
      ]

      const unsorted = {}

      exampleSort.forEach(el => {
        if (typeof unsorted[el] === 'undefined') unsorted[el] = []
      })

      pickPlan.open.forEach(el => {
        const shelfId = el.shelfSpaceId.split('-')[0]
        if (unsorted[shelfId]) {
          unsorted[shelfId].push(el)
        } else {
          console.warn(`shelfId ${shelfId} wasn't found`)
        }
      })
      pickPlan.open = []

      Object.keys(unsorted).map(key => {
        _.sortBy(unsorted[key], 'shelfSpaceId').map(el => pickPlan.open.push(el))
      })

      return pickPlan
    }
  }
})
